import React from "react";
import { connect } from "react-redux";
import { getFundNotes, addNoteToFund, deleteNote } from "store/state/fund";
import NotesDrawer from "components/Global/Notes/NotesDrawer";
import _ from "lodash";

class FundNotes extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const { fundId, isOpen } = this.props;
    const { isOpen: prevIsOpen } = prevProps;

    if (isOpen !== prevIsOpen && isOpen) {
      this.props.getFundNotes({
        modelName: "fund",
        modelId: fundId,
        subKey: fundId
      });
    }
  }

  handleRemove = noteId => {
    const { fundId } = this.props;

    this.props.deleteNote({
      noteId: noteId,
      shouldUpdateAfter: true,
      modelName: "fund",
      modelId: fundId,
      subKey: fundId
    });
  };

  render() {
    const { isOpen, closeNotes, fundNotes, fundId, addNoteToFund } = this.props;
    const specificFundNotes = fundNotes[fundId] || [];

    return (
      <React.Fragment>
        <NotesDrawer
          drawerWidth={600}
          addNote={note => addNoteToFund("fund", fundId, note)}
          isOpen={isOpen}
          closeDrawer={closeNotes}
          notes={specificFundNotes}
          handleRemove={this.handleRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ fund }) => ({
  fundNotes: fund.fundNotes
});

export default connect(
  mapStateToProps,
  {
    getFundNotes,
    addNoteToFund,
    deleteNote
  }
)(FundNotes);
